export default "__VITE_ASSET__DCDqCD6r__"